/**
 * @fileoverview Root layout: the shell every route renders inside.
 * @module App
 */

import { Outlet } from "react-router-dom"

import { AppHeader, SplashScreen } from "@/components/organisms"

import "@/styles/App.css"

/**
 * Application shell.
 *
 * @returns The layout wrapping the active route, the persistent brand
 *   header, plus the one-time mobile splash rendered above it.
 */
export default function App() {
	return (
		<div className="app">
			<SplashScreen />
			<AppHeader />
			<div className="app__content">
				<Outlet />
			</div>
		</div>
	)
}
